<button class="flex justify-center" mat-icon-button color="primary" (click)="copyToClipboard()">
  <mat-icon fontSet="material-icons-round" aria-hidden="false" aria-label="close icon">copy_all </mat-icon>
</button>
